import {Button, Result} from "antd";
import {useLocation, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";

const ErrorPage = () => {
    const navigate = useNavigate();
    const result = useLocation()
    const [code, setCode] = useState(404);
    const [error, setError] = useState("");

    useEffect(() => {
        const query = new URLSearchParams(result.search);
        if (query.get("code")) {
            setCode(Number(query.get("code")));
        }
    }, [result]);

    useEffect(() => {
        if (code === 403) {
            setError("无权限操作");
        } else if (code === 404) {
            setError("URL或资源不存在");
        } else if (code === 429) {
            setError("请求次数过多，请稍后再试");
        } else {
            setError("系统错误");
        }
    }, [code]);

    return (
        <Result
            status="404"
            title={code}
            subTitle={error}
            extra={
                <Button
                    type="primary"
                    onClick={() => {
                        navigate("/view/index", {replace: true});
                    }}
                >
                    返回首页
                </Button>
            }
        />
    );
}

export default ErrorPage;
